import { Fade, Tooltip, Typography } from '@mui/material';
import type { FC } from 'react';
import { CoverageDetailsTriggerStyle } from '../CoverageDetails.styles';
import type { CoverageDetailsProps } from '../CoverageDetails.types';
import CoverageDetailsContent from '../CoverageDetailsContent/CoverageDetailsContent';
import { TooltipPopperStyle } from './CoverageDetailsTooltip.styles';

const CoverageDetailsTooltip: FC<CoverageDetailsProps> = ({ triggerText, detailsKey }) => (
  <Tooltip
    title={<CoverageDetailsContent detailsKey={detailsKey} />}
    slotProps={{
      popper: {
        sx: TooltipPopperStyle,
      },
    }}
    slots={{
      transition: Fade,
    }}
  >
    <Typography sx={CoverageDetailsTriggerStyle}>{triggerText}</Typography>
  </Tooltip>
);

export default CoverageDetailsTooltip;
